/* Machine sticker links identify equipment; personal contact fields stay empty. */
(() => {
  const start = () => {
    const page = new URL(window.location.href);
    /* snippets/mcs-url-secrets.liquid lifts the token out of the URL before analytics load. */
    const token = (window.__mcsUrlSecrets || {}).machine || page.searchParams.get('machine');
    const form = document.querySelector('[data-commercial-service-form]');
    if (!token || !form) return;

    // The bearer link is unnecessary in analytics, enquiry emails or history
    // after this page has captured it. Preserve unrelated campaign parameters.
    page.searchParams.delete('machine');
    window.history.replaceState(window.history.state, '', page.pathname + page.search + page.hash);
    const section = form.closest('#commercial-enquire') || form;
    section.style.scrollMarginTop = '8rem';
    section.scrollIntoView({ behavior: 'instant', block: 'start' });
    const status = form.querySelector('[data-commercial-service-status]');
    const showStatus = (message, failed = false) => {
      if (!status) return;
      status.textContent = message;
      status.hidden = false;
      status.classList.toggle('commercial-enquiry__status--error', failed);
      status.classList.remove('commercial-enquiry__status--success');
    };
    const edited = new Set();
    let applying = false;
    let submitted = false;
    const recordEdit = (event) => {
      if (!applying && event.target.name) edited.add(event.target.name);
    };
    form.addEventListener('input', recordEdit);
    form.addEventListener('change', recordEdit);
    form.addEventListener('submit', () => { submitted = true; });
    const field = (name) => form.elements.namedItem(name);
    const fillText = (name, value) => {
      const input = field(name);
      if (input && !edited.has(name) && !input.value && typeof value === 'string') {
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };
    const choose = (inputs, value) => {
      if (typeof value !== 'string') return false;
      const input = Array.from(inputs).find((item) => item.value.toLowerCase() === value.toLowerCase());
      if (!input) return false;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };

    const load = async () => {
      showStatus('Loading machine details…');
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      try {
        if (!/^[A-Za-z0-9_-]{24}$/.test(token)) throw new Error('Invalid link');
        const response = await fetch('/apps/portal/commercial-service-enquiry/api/machine', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ token }),
          signal: controller.signal,
          cache: 'no-store'
        });
        const result = await response.json();
        if (!response.ok || !result.success || !result.machine) throw new Error('Lookup failed');
        if (submitted) return;
        const machine = result.machine;
        applying = true;
        ['company', 'machine_location', 'serial_number'].forEach((name) => fillText(name, machine[name]));
        if (!edited.has('machine_water')) {
          choose(form.querySelectorAll('[name="machine_water"]'), machine.machine_water);
        }
        const modelEdited = Array.from(edited).some((name) => name === 'machine_brand' || name.includes('_model'));
        if (!modelEdited && choose(form.querySelectorAll('[name="machine_brand"]'), machine.machine_brand)) {
          const group = Array.from(form.querySelectorAll('[data-commercial-service-model-group]'))
            .find((item) => item.dataset.commercialServiceModelGroup === machine.machine_brand);
          if (group && machine.machine_model) {
            const inputs = group.querySelectorAll('[data-commercial-service-model-input]');
            if (!choose(inputs, machine.machine_model) && choose(inputs, 'Other')) {
              const other = group.querySelector('[data-commercial-service-model-other]');
              if (other) other.value = machine.machine_model;
            }
          }
        }
        showStatus('Machine details filled in. Check them and enter your contact and site details.');
      } catch (_) {
        if (!submitted) showStatus('We couldn’t load this machine’s details. You can still complete the form below or call 1300 365 487.', true);
      } finally {
        applying = false;
        window.clearTimeout(timeout);
        form.removeEventListener('input', recordEdit);
        form.removeEventListener('change', recordEdit);
      }
    };
    load();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
